import { render, staticRenderFns } from "./CpfCnpjInput.vue?vue&type=template&id=732e9408"
import script from "./CpfCnpjInput.vue?vue&type=script&lang=js"
export * from "./CpfCnpjInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports